import Slider from '../components/SetupSlider.js';
import HamburgerMenu from '../components/SetupHamburgerMenu.js';
import Modals from '../components/SetupModals.js';
import Numbers from '../components/SetupNumberButtons.js';
import Buttons from '../components/SetupButtons.js';
import InstaFix from '../components/SetupInstaColumns.js';
import Animation from '../components/SetupAnimations.js';
import HeaderHeight from '../components/SetupHeaderHeight.js';
import OutOfStock from '../components/SetupOutOfStock.js';
import SetupHeaderNav from '../components/SetupHeaderNav';

export default {
  init() {
  // JavaScript to be fired on all pages
  Slider();
	HamburgerMenu();
	Modals();
	Numbers();
  Buttons();
  InstaFix();
  Animation();
  HeaderHeight();
  OutOfStock();
  SetupHeaderNav();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js